import _ from 'underscore';
import { formatISODuration, intervalToDuration } from 'date-fns';

import { logError } from '../logger';
import { getEmbedUrl } from '../materials';
import { getBaseMicrodata, getTextBlocksFromJsonField } from './helpers';

export const getVideoObjectMicrodata = (entity, entityType = 'movies') => {
	let microdata = [];

	try {
		const baseMicrodata = getBaseMicrodata(entity, {
			type: 'VideoObject',
			entityType
		});
		const video = _(entity.materials).filter({ type: 'video' });

		microdata = _(video).reduce((acc, material) => {
			if (
				video.length === 1 ||
				!material.subType ||
				material.subType === 'episode'
			) {
				const duration =
					material.files && material.files.length
						? material.files[0].duration
						: entity.duration;

				const videoObject = {
					'@type': 'VideoObject',
					'@context': 'http://schema.org',
					description:
						baseMicrodata.description ||
						getTextBlocksFromJsonField(entity.jsonText) ||
						material.title,
					url: baseMicrodata.url,
					name: material.title,
					uploadDate: material.publishDate,
					embedUrl: getEmbedUrl(material)
				};

				if (duration) {
					videoObject.duration = formatISODuration(
						intervalToDuration({ start: 0, end: 1000 * duration })
					);
				}

				if (baseMicrodata.image) {
					videoObject.thumbnailUrl = baseMicrodata.image.url;
					videoObject.thumbnail = baseMicrodata.image;
				}

				if (material.views && material.views.total) {
					videoObject.interactionStatistic = {
						'@type': 'InteractionCounter',
						userInteractionCount: material.views.total,
						interactionType: 'http://schema.org/WatchAction'
					};
				}

				acc.push(videoObject);
			}

			return acc;
		}, []);
	} catch (err) {
		logError(`videoObject microdata error: ${err.stack || err}`);
	}

	return microdata;
};
